import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {FPNetDate} from "@commons/types";
import {TipoElementoRML} from "@commons/mapping/ElementoRMLRecord";
import {LavoratoreSingoloElementoRML, NomeCampiTotalizzabili} from "@commons/mapping/LavoratoreRML";
import {badgeStyle, BadgeStyle, InfoType} from "@commons/components/BasicBadge";

export interface DettaglioRetribuzioneRecord extends URIAndTrace {
    idDip: number; // SOLO per PVA!!!
    codDip: number; // SOLO per PVA!!!
    codDipPaghe: number; // SOLO per PVA!!!
    nominativo: string; // SOLO per PVA!!!
    dataAssunzione: FPNetDate,
    dataAssConvenzionale: FPNetDate,
    dataFineTDET: FPNetDate,
    dataCessazione: FPNetDate,
    codQualifica: string,
    descrizioneQualifica: string,
    settoreCCNL: string,
    codContrattoUNILAV: string,
    codContrattoCCNL: string,
    descrizioneContratto: string,
    numMensilita: number,
    codLivello: string,
    percentualePT: number,
    codTabella: string;
    descrizioneTabella: string | null,

    elementi: LavoratoreSingoloElementoRML[],
    elementiPrec: LavoratoreSingoloElementoRML[] // elementi mese precedente
}

export class DettaglioRetribuzioneRecord {
    static getDescrizioneContratto = (dettaglio: DettaglioRetribuzioneRecord) => {
        return dettaglio.descrizioneContratto + ' [#' + dettaglio.codContrattoUNILAV + '/' + dettaglio.codContrattoCCNL + ']';
    }

    static getDescrizioneLavoratore = (dettaglio: DettaglioRetribuzioneRecord) => {
        if (dettaglio.nominativo)
            return dettaglio.nominativo + ' [#' + dettaglio.idDip + ']';
        else
            return '???';
    }
    static totaleElementi = (elementi: LavoratoreSingoloElementoRML[], item: NomeCampiTotalizzabili) => {
        let totale = 0
        for (let elemento of elementi)
            totale += elemento[item];
        return totale;
    }
    static getType = (id: number): InfoType => {
        switch (id) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                return DettaglioRetribuzioneRecord.getInfoType('NAZIONALE');
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
                return DettaglioRetribuzioneRecord.getInfoType('AD_PERSONAM');
            case 15:
            case 16:
            case 17:
                return DettaglioRetribuzioneRecord.getInfoType('TERRITORIALE');
            default:
                return DettaglioRetribuzioneRecord.getInfoType('ALTRO');
        }
    }

    static getInfoType = (tipo: TipoElementoRML): InfoType => {
        switch (tipo) {
            case "NAZIONALE":
                return 'primary';
            case "TERRITORIALE":
                return 'warning';
            case "AD_PERSONAM":
                return 'success';
            default:
                return 'info';
        }
    }
    static getStyle = (tipo: TipoElementoRML): BadgeStyle => {
        switch (tipo) {
            case "NAZIONALE":
                return badgeStyle.primary;
            case "TERRITORIALE":
                return badgeStyle.warning;
            case "AD_PERSONAM":
                return badgeStyle.success;
            default:
                return badgeStyle.info;
        }
    }
    static getGroupIndex = (id: number): number | null => {
        switch (id) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                return id;
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
                return id - 7 + 1;
            case 15:
            case 16:
            case 17:
                return id - 15 + 1;
            default:
                return null;
        }
    }
}
